import { UserAuth } from './authentication/UserAuthentication';

export const getUserEmail = () => {
  const token = localStorage.getItem('idToken');
  if (!token) return;
  const user = new UserAuth(token);
  return user.getUserEmail();
};
